import { Presentation } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useApp } from "../context/AppContext";

// The two shared demo enterprises (backend/demo_orgs.py DEMO_IDS): everyone inside them sees this strip.
export const DEMO_ORGS = ["buma-demo-school", "buma-demo-centre"];
export const isDemoUser = (u) => DEMO_ORGS.includes(u?.org_id);

export function DemoBanner({ className = "" }) {
  const { user } = useAuth();
  const { lang } = useApp();
  if (!isDemoUser(user)) return null;
  return <div role="note" data-testid="demo-banner" className={`flex items-center justify-center gap-2 bg-amber-100 text-amber-900 text-xs sm:text-sm font-semibold px-3 py-1.5 text-center ${className}`}>
    <Presentation size={15} className="shrink-0" />
    <span>{lang === "ar" ? "هذا حساب تجريبي مشترك — جرّب كل شيء بحرية. لا تُرسل أي رسائل حقيقية، ويعود كل شيء إلى أصله كل ليلة." : "Shared demo — try anything. No real messages are sent, and everything resets every night."}</span>
  </div>;
}
